module.exports = __webpack_public_path__ + "assets/images/outfit-01.f5ef2db2a951d80e4ff10a7363d8e4d8.svg";